import { Component } from '@angular/core';
import { Router, ActivatedRoute} from '@angular/router';
import {  OnInit } from '@angular/core';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent implements OnInit{
  title = 'VisitingCard';
data:string;
  ngOnInit() {
    this.data=sessionStorage.getItem('data');
  }

  constructor(private router: Router, private route: ActivatedRoute) {
  }
}
